import React from 'react';

/**
 * Reusable Loading Spinner Component
 * Provides consistent loading UI across the application
 * 
 * @param {string} message - Loading message to display
 * @param {string} size - Spinner size: 'sm', 'md', 'lg'
 * @param {boolean} fullScreen - Whether to show full screen overlay
 * @param {string} className - Additional CSS classes
 */
const LoadingSpinner = ({ 
  message = 'Loading...', 
  size = 'md',
  fullScreen = false,
  className = ''
}) => {
  const sizeClasses = {
    sm: 'h-4 w-4 border-2',
    md: 'h-8 w-8 border-b-2',
    lg: 'h-12 w-12 border-b-2'
  };

  const spinner = (
    <div className={`text-center ${fullScreen ? 'py-12' : 'py-4'} ${className}`}>
      <div className={`inline-block animate-spin rounded-full ${sizeClasses[size]} border-blue-600`}></div>
      {message && (
        <p className={`mt-2 theme-text ${size === 'sm' ? 'text-sm' : ''}`}>
          {message}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;



